export const SCHOOL_REQUEST = 'SCHOOL_REQUEST';
export const SCHOOL_SUCCESS = 'SCHOOL_SUCCESS';
export const SCHOOL_FAILURE = 'SCHOOL_FAILURE';

export const SCHOOL_SEARCH_REQUEST = 'SCHOOL_SEARCH_REQUEST';
export const SCHOOL_SEARCH_SUCCESS = 'SCHOOL_SEARCH_SUCCESS';
export const SCHOOL_SEARCH_FAILURE = 'SCHOOL_SEARCH_FAILURE';

export const SCHOOL_CHILD_SCHOOLS_REQUEST = 'SCHOOL_CHILD_SCHOOLS_REQUEST';
export const SCHOOL_CHILD_SCHOOLS_SUCCESS = 'SCHOOL_CHILD_SCHOOLS_SUCCESS';
export const SCHOOL_CHILD_SCHOOLS_FAILURE = 'SCHOOL_CHILD_SCHOOLS_FAILURE';
